import { useState, useEffect, useCallback } from 'react';

interface UseTimerProps {
  seconds: number;
}

interface UseTimerReturn {
  timeLeft: number;
  isActive: boolean;
  startTimer: () => void;
  resetTimer: () => void;
  setTimeLeft: (time: number) => void;
}

const useTimer = ({ seconds }: UseTimerProps): UseTimerReturn => {
  const [timeLeft, setTimeLeft] = useState<number>(seconds);
  const [isActive, setIsActive] = useState<boolean>(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (isActive && timeLeft > 0) {
      timer = setTimeout(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    } else if (timeLeft <= 0) {
      setIsActive(false);
    }

    return () => clearTimeout(timer);
  }, [isActive, timeLeft]);

  const startTimer = useCallback(() => {
    setIsActive(true);
  }, []);

  const resetTimer = useCallback(() => {
    setIsActive(false);
    setTimeLeft(seconds);
  }, [seconds]);

  return { timeLeft, startTimer, resetTimer, isActive, setTimeLeft };
};

export default useTimer;
